import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { withAsyncPaginate } from "react-select-async-paginate";
const AsyncPaginate = withAsyncPaginate(Select);

const SelectAsyncPaginateDrivers = (props) => {
    const [reloadKey, setReloadKey] = useState(0);

    const loadOptions = async (
        searchQuery,
        loadedOptions,
        { page }
    ) => {
        const token = JSON.parse(localStorage.getItem("user")).token;
        const response = await fetch(
            `${props.apiLink}?search=${searchQuery}&pageNumber=${page}&pageSize=10${props?.isClear ? "&justClear=true" : ""}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const responseJSON = await response.json();
        const optionsList = responseJSON?.drivers?.map((item) => ({
            label: item.firstName + " " + item.lastName, 
            value: item?.id,
            item: item
        }));

        return {
            options: optionsList,
            hasMore: responseJSON?.pagination?.hasNextPage,
            additional: {
                page: page + 1,
            },
        };
    };

    const onChange = (option) => {
        if (typeof props.onChange === "function") {
            props.onChange(option);
        }
    };

    useEffect(() => {
        if (props.reload) {
            setReloadKey(prevKey => prevKey + 1);
        }
    }, [props.reload]);


    useEffect(() => {
            if(props.isClear !== undefined) {
                setReloadKey(prevKey => prevKey + 1);
            }
    }, [props.isClear]);
    
    return (
        <AsyncPaginate
            key={reloadKey}
            loadOptions={loadOptions}
            value={props?.value}
            onChange={onChange}
            placeholder={props?.placeholder}
            additional={{
                page: 1,
            }}
            isDisabled={props?.isDisabled}
            className={props?.width}
            isClearable={props?.isClearable}
            isMulti={props?.isMulti}
        />
    );
};

SelectAsyncPaginateDrivers.propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
};

export default SelectAsyncPaginateDrivers;
